import closeAllUILessAddinsForItem from './closeAllUILessAddinsForItem';
import { closeAllAutoRunCommandsforHostItemIndex } from 'owa-addins-store';

export default function onComposeClose(hostItemIndex: string) {
    closeAllUILessAddinsForItem(hostItemIndex);
    closeAllAutoRunCommandsforHostItemIndex(hostItemIndex);
}
